import { Users, Zap, Trophy } from "lucide-react"
import HeroSection from "../components/HeroSection"
import FeatureCard from "../components/FeatureCard"
import GameCard from "../components/GameCard"
import HowItWorks from "../components/HowItWorks"
import Testimonials from "../components/Testimonials"
import FAQ from "../components/FAQ"
import CTASection from "../components/CTASection"

export default function LandingPage() {
  return (
    <main className="min-h-screen bg-gradient-to-b from-black to-zinc-900 text-white">
      <HeroSection />

      {/* Features Section */}
      <section className="container mx-auto px-4 py-20">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Level Up Your Squad</h2>
          <p className="text-zinc-400 max-w-2xl mx-auto">
            FragNades connects you with players that match your skill level and playstyle for the ultimate gaming
            experience.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <FeatureCard
            icon={<Users className="h-10 w-10 text-red-500" />}
            title="Skill-Based Matching"
            description="Connect with players at your skill level or find teammates to help you rank up faster."
          />
          <FeatureCard
            icon={<Zap className="h-10 w-10 text-red-500" />}
            title="AI-Powered Matchmaking"
            description="Our advanced AI analyzes playstyles and preferences to create the perfect squad."
          />
          <FeatureCard
            icon={<Trophy className="h-10 w-10 text-red-500" />}
            title="Competitive Edge"
            description="Gain the advantage with teammates who complement your strengths and cover your weaknesses."
          />
        </div>
      </section>

      {/* Games Section */}
      <section className="bg-zinc-900/50 py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Supported Games</h2>
            <p className="text-zinc-400 max-w-2xl mx-auto">
              Currently focused on Valorant with more games coming soon.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <GameCard name="Valorant" status="active" image="game_images/valorant1.jpg" />
            <GameCard name="CS2" status="coming-soon" image="game_images/cs2.jpg" />
            <GameCard name="Apex Legends" status="coming-soon" image="game_images/apex_legends.jpg" />
            <GameCard name="League of Legends" status="coming-soon" image="game_images/league_of_legends.jpg" />
          </div>
        </div>
      </section>

      <HowItWorks />
      <Testimonials />
      <FAQ />
      <CTASection />

      {/* Footer */}
      <footer className="bg-black py-10">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-6 md:mb-0">
              <h2 className="text-2xl font-bold text-red-500">FragNades</h2>
              <p className="text-zinc-500 mt-2">Find your perfect squad.</p>
            </div>
            <div className="flex space-x-8">
              <a href="#" className="text-zinc-400 hover:text-white transition">
                About
              </a>
              <a href="#" className="text-zinc-400 hover:text-white transition">
                Privacy
              </a>
              <a href="#" className="text-zinc-400 hover:text-white transition">
                Terms
              </a>
              <a href="#" className="text-zinc-400 hover:text-white transition">
                Contact
              </a>
            </div>
          </div>
          <div className="border-t border-zinc-800 mt-8 pt-8 text-center text-zinc-500">
            <p>© {new Date().getFullYear()} FragNades. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </main>
  )
}

